import ProductTypeDto from '@core/mappers/bonus/dtos/ProductTypeDto';
import { BonusTypeDto } from '@core/models/bonus/BonusTypeDto';

export interface BalanceDto {
    ErrorMessage: null;
    StatusCode: string;
    Accounts: AccountDto[];
    RecordCount: number;
}

export type AccountDto = RegularAccountDto | BonusAccountDto | UnusedAccountDto;

interface AccountDtoBase {
    Balance: number;
    InitiallyLockedAmount: number;
    LockedAmount: number;
}

export interface RegularAccountDto extends AccountDtoBase {
    AccountType: AccountType.Regular;
    Currency: string;
    Name: null;
    WagerType: null;
    Wagered: null;
    WageringRequirement: null;
}

export interface BonusAccountDto extends AccountDtoBase {
    AccountType: AccountType.Bonus;
    BonusType: BonusTypeDto;
    BonusCategoryId?: BonusCategoryDto;
    PlayerBonusId?: number;
    ProductType: ProductTypeDto;
    Currency: string;
    Name: string;
    WagerType: number;
    Wagered: number;
    WageringRequirement: number;
}

// we don't use this object
export interface UnusedAccountDto extends AccountDtoBase {
    AccountType: AccountType.Unused;
    Currency: null;
    Name: 'N/A';
    WagerType: null;
    Wagered: null;
    WageringRequirement: null;
}

export enum AccountType {
    Regular = 1,
    Bonus = 2,
    Unused = 3,
}

export const BonusSubCategory = {
    FirstDeposit: 1,
    Reload: 2,
    Rebate: 3,
    Cashback: 4,
    FreeSpins: 5,
    AwardGames: 6,
    FreeBet: 7,
} as const;

export type BonusCategoryDto = typeof BonusSubCategory[keyof typeof BonusSubCategory];
